export default __webpack_public_path__ + "static/media/997.dee21e71.png";